import { type SerializedPageStructure } from '@wix/document-services-types'

export const setPageLoginRequirement = ({
  page,
  pageRequiresLogin,
}: {
  page: SerializedPageStructure
  pageRequiresLogin: boolean
}): SerializedPageStructure => ({
  ...page,
  data: {
    ...page.data,
    pageSecurity: {
      ...page.data.pageSecurity,
      requireLogin: pageRequiresLogin,
    },
  },
})
